module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/number_order_index-f60d2db775c5e0bcf1e79117f870535d.png";